<template>
  <Submenu :name="menuList.meta.order">
    <!-- 父级菜单 -->
    <template slot="title">
      <Icon :type="menuList.type" />
      <span>{{ menuList.meta.title }}</span>
    </template>
    <template v-for="item in menuList.children">
      <!-- 如果还有子集，继续调用   -->
      <left-menu-nav v-if="item.children&&item.children.length!==0" :menuList='item' :key='item.index'>
      </left-menu-nav>
      <!-- 子菜单  -->
      <menu-item v-else :key="item.id" :name="item.meta.order" :to="item.path">
        <Icon :type="item.type" />
        <span>{{ item.meta.title }}</span>
      </menu-item>
    </template>
  </Submenu>
</template>
<script>
export default {
  name: 'leftMenuNav',
  props: {
    menuList: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {

    }
  }
}
</script>
<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/leftMenuNav.vue